import { BaseApi } from 'src/api/BaseApi';

class AuthApi extends BaseApi {
  async login(email, password) {
    const formData = this.createFormData({ email, password });
    const response = await this.postRequest('auth/login', formData, true);
    return response.data;
  }

  async expertSendToken(email, queryID, reportID, name, company, subject, additionalInformation) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        tokenSent: true,
        email,
        queryID,
        reportID,
      });
    }

    const formData = new FormData();
    if (email) formData.append('email', email);
    if (queryID) formData.append('queryID', queryID);
    if (reportID) formData.append('reportID', reportID);
    if (name) formData.append('name', name);
    if (company) formData.append('company', company);
    if (subject) formData.append('subject', subject);
    if (additionalInformation) formData.append('additionalInformation', additionalInformation);

    formData.forEach((value, key) => {
      console.log(key, value); // eslint-disable-line no-console
    });

    const response = await this.postRequest('experts/login', formData, true);

    console.log('expertSendToken response', response);

    return response.data;
  }

  async expertLogin(token) {
    const formData = this.createFormData({ token });
    const response = await this.postRequest('experts/auth', formData, true);
    return response;
  }
}

export const authApi = new AuthApi();
